import React, { useCallback, useRef, useEffect, useState } from "react";
import { Box, Button, InputField, Modal, useToast } from "fds";
import "./index.scss";
import { DocInfo } from "../../types/files";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { nanoid } from "@reduxjs/toolkit";
import { t } from "i18next";

interface ChangeFileNameModalProps {
  open: boolean;
  onClose: () => void;
  docInfo?: DocInfo;
}
const ChangeFileNameModal: React.FC<ChangeFileNameModalProps> = ({
  open,
  onClose,
  docInfo,
}) => {
  /** Hook 정리 */
  const toast = useToast();
  const { setChangeDocName } = useDocumentStore();

  /** State 정리 */
  const [contentName, changeContentName] = useState(
    docInfo?.contentName.slice(0, docInfo.contentName.lastIndexOf("."))
  ); // 새 이름

  /** useEffect 정리 */
  useEffect(() => {
    changeContentName(
      docInfo?.contentName.slice(0, docInfo.contentName.lastIndexOf("."))
    );
  }, [docInfo]);

  /** 함수 정리 */
  /** 수정된 파일 이름으로 저장 */
  const handleChangeContentName = async () => {
    if (!contentName || !docInfo) return;
    const extension = docInfo?.contentName.slice(
      docInfo.contentName.lastIndexOf(".")
    );
    let resp: any = await setChangeDocName({
      contentName: contentName.trim() + extension,
      syncId: docInfo?.syncId,
    });
    if (resp.payload) {
      toast.toastMsg(
        nanoid(),
        t("file.alert.changeFileNameSuccess"),
        "success"
      );
      onClose();
    } else {
      if (resp.error.name === "INTERNAL_SERVER_ERROR") {
        toast.toastMsg(nanoid(), t("file.alert.duplicateFileName"), "error");
      } else {
        toast.toastMsg(
          nanoid(),
          t("file.alert.noPermissionChangeName"),
          "error"
        );
      }
    }
  };
  return (
    <Modal
      title={t("file.renameFile")}
      open={open}
      onClose={onClose}
      width={540}
      footer={
        <Box>
          <Button
            btnStyle="fill"
            label={t("common.cancel")}
            type="secondary"
            onClick={onClose}
          />
          <Button
            btnStyle="fill"
            label={t("common.save")}
            state={
              contentName?.trim()?.length === 0 ||
              contentName?.trim() === docInfo?.contentName
                ? "disable"
                : "default"
            }
            onClick={handleChangeContentName}
          />
        </Box>
      }
      body={
        <Box width="100%">
          <InputField
            placeholder={t("file.renameFilePlaceholder")}
            size="md"
            width="100%"
            value={contentName}
            onChange={(e) => changeContentName(e.target.value)}
            maxLength={245}
          />
        </Box>
      }
    />
  );
};
export default ChangeFileNameModal;
